// ============================================================================
// EXPONENTIAL SEARCH - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'exponential-search',
  name: 'Exponential Search',
  category: 'Search',
  complexity: {
    time: 'O(log n)',
    space: 'O(1)'
  },
  description: 'Exponential Search works by finding a range where the target may be present using exponential doubling, then performs binary search within that range. It is particularly useful for unbounded or infinite sorted arrays.'
};
export type MetaType = typeof meta;
